import { AccountInfo, IPublicClientApplication, InteractionRequiredAuthError } from "@azure/msal-browser";
import { THANOS26_API_SCOPES } from "../config";
import { callMSGraphPhoto, callMSGraphUser } from "../api/graph";
import { User } from "@microsoft/microsoft-graph-types";

export function isAdmin(account: AccountInfo | null): boolean {
    if (!account) {
        return false;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let token: any = account.idTokenClaims;
    let roles: string[] = token.roles;
    if (!roles) return false;
    return roles.includes("Admin");
}

export async function getThanos26Token(forceRefresh = false): Promise<string> {
    return getAccessToken(THANOS26_API_SCOPES, forceRefresh);
}

export async function getAccessToken(scopes: string[], forceRefresh = false): Promise<string> {
    const { instance, account } = AccountData.GetAccountData();
    if (!instance || !account) throw new Error("Nicht angemeldet");

    try {
        // Returns the cached token if it is still valid, otherwise MSAL refreshes it silently
        const result = await instance.acquireTokenSilent({ scopes, account, forceRefresh });
        return result.accessToken;
    } catch (err) {
        // Only an interaction (login / consent) can resolve this, all other errors are passed on
        if (err instanceof InteractionRequiredAuthError) {
            const result = await instance.acquireTokenPopup({ scopes, account });
            return result.accessToken;
        }
        throw err;
    }
}

export class AccountData {
    private static instance: IPublicClientApplication;
    private static account: AccountInfo;
    private static user: User;
    private static userImage: Blob;

    // Marked private to enforce singleton pattern.
    private constructor() {}

    public static GetAccountData() {
        return { instance: this.instance, account: this.account };
    }

    public static async setAccountData(instance: IPublicClientApplication, account: AccountInfo): Promise<any> {
        this.instance = instance;
        this.account = account;
        this.user = await callMSGraphUser();
        this.userImage = await callMSGraphPhoto().catch(console.log);
        return Promise.resolve();
    }

    public static getUser(): User {
        return this.user;
    }

    public static getUSerImage() {
        return this.userImage;
    }
}
